import React, { FC } from 'react';
import { ICategoriesHome2 } from './params';
import Styles from './styles';
import convertToSlug from '../../../utils/convertToSlug';
import { common, routing } from '../../../translates';

const CategoriesHome: FC<{ config: ICategoriesHome2; categories: string[]; language: string }> = ({
  config,
  categories,
  language,
}) => (
  <Styles $config={config}>
    <div className="categories-home">
      <div className="container">
        <h3 className="categories-home-header">{common[language].sectionCategoriesHome}</h3>
        <div className="categories-home-wrapper">
          {categories?.map((category) => (
            <a
              key={category}
              href={`${routing[language].articles}/${convertToSlug(category)}/`}
              className="categories-home-category"
            >
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="chevron-right"
                className="svg-inline--fa fa-chevron-right "
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
              >
                <path
                  fill="currentColor"
                  d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
                ></path>
              </svg>
              {category}
            </a>
          ))}
        </div>
      </div>
    </div>
  </Styles>
);

export default CategoriesHome;
